import { type LoaderFunctionArgs, json } from '@remix-run/node'
import { useLoaderData } from '@remix-run/react'
import { H6 } from '#app/components/typography/h6.tsx'
import { P } from '#app/components/typography/p.tsx'
import { sessionKey } from '#app/utils/auth.server.ts'
import { prisma } from '#app/utils/db.server.ts'
import { authSessionStorage } from '#app/utils/session.server.ts'
import { readSource } from '../sections/sections.server.tsx'
import { Description, Features, Source, type componentProps, Parts, Usage, Styling } from '../sections/sections.tsx'

export const handle = {
	breadcrumb: 'H6',
}

const component: componentProps = {
	name: 'H6',
	shortName: 'H6',
	fileName: 'h6',
	category: 'typography',
	description: ['An h6 element with control for typographic attributes.'],
	features: ['Drop-in replacement for the native <h6> element.', 'Automatically inherits design tokens.', 'Allows control of size, weight, alignment, and tracking.'],
	parts: [],
	usage: `<H6>This is an h6 heading.</H6>`,
	styling: ``,
}

export const loader = async ({ request }: LoaderFunctionArgs) => {
	const authSession = await authSessionStorage.getSession(request.headers.get('cookie'))
	const sessionId = authSession.get(sessionKey)
	const session =
		sessionId ?
			await prisma.session.findUnique({
				select: { user: { select: { id: true, paid: true } } },
				where: { id: sessionId, expirationDate: { gt: new Date() } },
			})
		:	null
	const source = session?.user.paid ? await readSource({ category: component.category, fileName: component.fileName }) : null
	return json({ source })
}

const HeadingRoute = () => {
	const { source } = useLoaderData<typeof loader>()
	const { name, description, shortName, fileName, features, usage, parts, styling } = component

	return (
		<>
			<Description name={name} description={description} />
			<Features features={features} />
			<Parts parts={parts} />
			<P className="mt-4">Note that the tracking's default value depends on the size prop and is controlled through CSS variables.</P>
			<Usage usage={usage} shortName={shortName} />
			<H6>This is an h6 heading.</H6>
			<Source source={source} fileName={fileName} />
			<Styling styling={styling} />
		</>
	)
}
export default HeadingRoute
